module.exports = __webpack_public_path__ + "static/media/principal-logo.57b42e95.png";